"use client"

import { useContext } from "react";
import { Alert } from "react-bootstrap";
import { WebSocketContext } from "../../websocket/websocket";
import { useScreenSize } from "../../contexts/screenSizeContext";
import { useReadonly } from "../../contexts/readonlyContext";
import { useTariffsModal } from "../../contexts/tariffsModalContext";
import "./connectionStatus.css";
import Icon from "../Icon";
import { faWifi, faLock, faSync, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const ConnectionStatus: React.FC = () => {
    const { connected, reconnect, syncDone, syncInProgress } = useContext(WebSocketContext)!;
    const screenSize = useScreenSize();
    const { readonly } = useReadonly();
    const { openTariffs } = useTariffsModal();
    const isMobile = screenSize === "MOBILE";

    // Десктоп — как было
    if (!isMobile) {
        // Readonly
        if (readonly) {
            const statusClass = connected ? "connected" : "offline";
            const statusText = connected ? "Онлайн" : "Офлайн";
            return (
                <div className={`connection-status-desktop readonly ${statusClass}`} title="Режим только чтения — оплата не активна" onClick={openTariffs}>
                    <Icon icon={faWifi} className="connection-status-icon" />
                    <span className="connection-text">
                        🔒 Только чтение · {statusText}
                    </span>
                </div>
            );
        }
        // Офлайн
        if (!connected) {
            return (
                <button className="connection-status-desktop offline" onClick={reconnect} title="Нет соединения - нажмите для переподключения">
                    <Icon icon={faWifi} className="connection-status-icon" />
                    <span className="connection-text">Офлайн</span>
                </button>
            );
        }
        // Онлайн / синхронизация
        return (
            <button className="connection-status-desktop connected" title="Подключено" onClick={openTariffs}>
                <Icon icon={faWifi} className="connection-status-icon" />
                <span className="connection-text">
                    {syncInProgress || !syncDone ? "Синхронизация..." : "Онлайн"}
                </span>
            </button>
        );
    }

    // === Мобильная версия ===
    // Readonly
    if (readonly) {
        return (
            <Alert variant="secondary" className="connection-status-mobile d-flex align-items-center justify-content-center gap-2 mb-0 rounded-0" onClick={openTariffs} style={{ cursor: "pointer" }}>
                <Icon icon={faLock} />
                <span>Только чтение</span>
            </Alert>
        );
    }

    // Офлайн
    if (!connected) {
        return (
            <Alert
                variant="danger"
                className="connection-status-mobile d-flex align-items-center justify-content-center gap-2 mb-0 rounded-0"
                onClick={reconnect}
                style={{ cursor: "pointer" }}
            >
                <Icon icon={faTriangleExclamation} />
                <span>Нет соединения — нажмите для переподключения</span>
            </Alert>
        );
    }

    // Синхронизация
    if (syncInProgress || !syncDone) {
        return (
            <Alert variant="info" className="connection-status-mobile d-flex align-items-center justify-content-center gap-2 mb-0 rounded-0" onClick={openTariffs} style={{ cursor: "pointer" }}>
                <Icon icon={faSync} spin />
                <span>Синхронизация...</span>
            </Alert>
        );
    }

    // Всё хорошо — не показываем ничего на мобильных
    return null;
};

export default ConnectionStatus;